module.exports = __webpack_public_path__ + "img/saving.c6435640.svg";